import { useCallback } from 'react'

import { stringUtils } from '@enechain/eposition-utils'

import { useGetMe } from '~/pages/hooks/useGetMe'

import { Event, InferEventPaylaod } from './events'

export interface UseDataLayerReturn {
  push: <T extends Event>(event: T, payload: InferEventPaylaod<T>) => void
}

export function useDataLayer(): UseDataLayerReturn {
  const { memberId, organizationId } = useGetMe()
  const push = useCallback(
    <T extends Event>(event: T, payload: InferEventPaylaod<T>) => {
      const gtmId = import.meta.env.VITE_GTM_ID as string
      if (stringUtils.isEmpty(gtmId)) {
        return
      }
      const tm = window.google_tag_manager?.[gtmId]
      if (tm !== undefined && tm.dataLayer !== undefined) {
        tm.dataLayer.reset()
      }
      window.dataLayer = window?.dataLayer ?? []
      window.dataLayer.push({
        event,
        memberId,
        organizationId,
        ...payload,
      })
    },
    [memberId, organizationId],
  )

  return {
    push,
  }
}
